import { createElement, type ReactElement } from 'react'

import { PropertiesTag } from '@graftcode/design-system'

import { getBadgeType } from '@/core/utils/getBadgeType'
import { getPropertiesTagVariant } from '@/core/utils/getPropertiesTagVariant'

export const createTreeBadgeContent = (label: string): ReactElement => {
  const variant = getPropertiesTagVariant(getBadgeType(label))

  return createElement(PropertiesTag, {
    variant,
    withoutIcon: true,
    children: label,
  })
}
